export default () => {

  if ($('.js-sticky-nav').length) {

    $.fn.isSticky = function(options) {

      const defaults = {
        element: $(this),

        // Z-index of element
        zIndex: '',

        // Stopper element selector, also accepts number value
        stopper: '',

        // Class applied to element when it's stuck
        stuckClass: '-stuck'
      };

      // Accepts custom stopper id or class
      const settings = $.extend({}, defaults, options);

      // Where we want it to start being sticky
      let stickyPoint = settings.element.offset().top;

      $(window).on('resize', () => {
        stickyPoint = settings.element.offset().top;
      });

      // Elements width
      let thisWidth = settings.element.parent().outerWidth();

      // Cache a clone sticky element
      const placeholder = $('<div class="js-sticky-placeholder"></div>').width(thisWidth).height(settings.element.outerHeight());

      // Checks if stopper was defined
      settings.hasStopper = function() {
        return 0 < $(this.stopper).length || typeof this.stopper === 'number' ? true : false;
      };

      // Inserts a placeholder where the element used to be to prevent content from moving
      settings.insertPlaceholder = function() {
        return stickyPoint < $(window).scrollTop() && placeholder.length < 2 ? this.element.after(placeholder) : placeholder.remove();
      };

      // Sets position fixed vs static
      settings.setPosition = function() {
        return stickyPoint < $(window).scrollTop() ? 'fixed' : '';
      };

      // Sets top position
      settings.setTop = function() {
        const data = {
          windowTop: $(window).scrollTop(),
          stopPoint: settings.hasStopper ? $(this.stopper).offset().top - this.element.outerHeight() : 0
        };

        if (stickyPoint < data.windowTop) {
          if (settings.hasStopper && data.stopPoint < data.windowTop) {
            return data.stopPoint - data.windowTop;
          }
          return 0;
        }
        return '';
      };

      // Sets element's width when stuck
      settings.setWidth = function(e) {

        if (e.type === 'resize') {

          // Re-calculate width
          thisWidth = settings.element.parent().outerWidth();

          // Reset width/height of placeholder
          placeholder.width(thisWidth).height(settings.element.outerHeight());
        }

        return stickyPoint < $(window).scrollTop() ? thisWidth : '';
      };

      // Sets element's z-index when stuck
      settings.setIndex = function() {
        return typeof this.zIndex === 'number' && stickyPoint < $(window).scrollTop() ? this.zIndex : '';
      };

      // Sets element's class when stuck
      settings.setClass = function() {
        return stickyPoint < $(window).scrollTop() ? this.element.addClass(this.stuckClass) : this.element.removeClass(this.stuckClass);
      };

      // Appplies position, top, width and z-index when stuck
      settings.applyCSS = function(e) {
        return this.element.css({
          'position': settings.setPosition(),
          'top': settings.setTop(),
          'width': settings.setWidth(e),
          'z-index': settings.setIndex()
        });
      };

      // Resets CSS of element
      settings.resetCSS = function() {
        return this.element.css({
          'position': '',
          'top': '',
          'width': '',
          'z-index': ''
        });
      };

      // Removes placeholder element
      settings.removePlaceholder = function() {
        return placeholder.remove();
      };

      // Wrapper function to call necessary functions for functionality
      settings.stickyScroll = function(e) {
        settings.applyCSS(e);
        settings.setClass();
        settings.insertPlaceholder();
      };

      // Initializes the sticky function and binds
      settings.init = function() {
        if ($(window).innerHeight() > this.element.outerHeight()) {
          $(window).on('scroll load resize', this.stickyScroll);
        }
      };

      // Removes event binding for sticky function, removes placeholder, and resets CSS of element
      settings.destroy = function() {
        $(window).off('scroll load resize', this.stickyScroll);
        settings.resetCSS();
        settings.removePlaceholder();
      };

      return settings;
    };

    $(function() {
      const isStickyNav = $('.js-sticky-nav').isSticky({
        zIndex: 99,
        stopper: 'footer',
        stuckClass: '-stuck'
      });

      isStickyNav.init();
    });

    $('.js-community-detail-dropdown-trigger').on('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      $(e.target).parent().toggleClass('-active');
      $('.community-detail-dropdown').toggleClass('-active');

      if ($('.community-detail-dropdown').hasClass('-active') && screen.width < 1000) {
        $('.js-community-detail-dropdown-trigger').html('Close Details');
      } else {
        $('.js-community-detail-dropdown-trigger').html('Community Details');
      }
    });

    $(document).on('click', () => {
      $('.community-detail-dropdown-trigger').removeClass('-active');
      $('.community-detail-dropdown').removeClass('-active');
    });

    $(window).on('resize', () => {
      if (screen.width >= 1000) {
        $('.js-community-detail-dropdown-trigger').html('Community Details');
      } else if (screen.width < 1000 && $('.community-detail-dropdown').hasClass('-active')) {
        $('.js-community-detail-dropdown-trigger').html('Close Details');
      }
    });

  }

};
